module.exports = __webpack_public_path__ + "media/images/smile-1-7316729f220ec115d53f23fc63975c2a.svg";